export default {
  QUOTE: "Quote",
  QUOTES: "Quotes",
};
